export const DEFAULT_LIMIT = 20;

export const FAST_LISTING_CONFIRM_MESSAGE = (
  <>
    Tıkla Sat işleminde toplu işlem fonksiyonu kullanılırsa ürünler stok ve fiyat bilgisi olmadan gönderilir; Eşleşen ürünleri{' '}
    <strong>Ürünlerim &gt; Eşleşen Ürünler</strong> ekranından onayladıktan sonra{' '}
    <strong>Envanter</strong> ekranından stok ve fiyat girerek satışa başlayabilirsiniz.
  </>
);
